import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { BenefitsBanner } from "../components/site/BenefitsBanner";
import { Services } from "../components/site/Services";
import { WhyUs } from "../components/site/WhyUs";
import { Testimonials } from "../components/site/Testimonials";
import { Coverage } from "../components/site/Coverage";
import { FAQSection } from "../components/site/FAQSection";
import { CTASection } from "../components/site/CTASection";
import { Footer } from "../components/site/Footer";
import { FloatingWhatsApp } from "../components/site/FloatingWhatsApp";

export default function Home() {
    return (
        <div className="min-h-screen bg-white text-black antialiased pb-16 md:pb-0">
            <Header />
            <main>
                <Hero />
                <BenefitsBanner />
                <Services />
                <WhyUs />
                <Testimonials />
                <Coverage />
                <FAQSection />
                <CTASection />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}
